import { Option } from '../../../../general-types';

export const deleteOptionsByValues = <TOption extends Option>(
  options: TOption[],
  values: TOption['value'][],
) => {
  return options.filter((option) => !values.includes(option.value));
};
